import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router";

import styled from 'styled-components'

export const Wrapper = styled.article`
  line-height: 3px;

  .login-container {
    display: grid;
    grid-template-columns: 1fr 2fr;
  }
  .user-name-para {
    font: 14px/22px var(--body-font);
    margin-top: 0.5rem;
    margin-left: 0.8rem;
  }
`

/**
 * if auth.isAuthenticated, should have JWT access token:
 * 
 * eyJraWQiOiJqQ1dkTjRidE1UVHlsSjhhS1AzOVBJQm9ub0RlQ01Zem1iemYxXC9aSXV3OD0iLCJhbGciOiJSUzI1NiJ9
 * .
 * eyJzdWIiOiIyOTRlODQwOC1iMGExLTcwYTUtYjUxMS0wZGI1NjFmMWUzMGYiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuYXAtc291dGhlYXN0LTIuYW1hem9uYXdzLmNvbVwvYXAtc291dGhlYXN0LTJ
 * fOVhVTEN1TzlQIiwidmVyc2lvbiI6MiwiY2xpZW50X2lkIjoiNGQzZTZkZG5tZzdqbWdwZ2JobWJqdjl2YzgiLCJvcmlnaW5fanRpIjoiN2M2YjYyZTItZDE0Yi00ODQ1LTk1OGItZjc4YzBlMzE2NTZkIiwiZX
 * ZlbnRfaWQiOiJmMWRhY2Q0My03OGZkLTRkYWUtYTcyZC1iNjA0YThiMTZkZmEiLCJ0b2tlbl91c2UiOiJhY2Nlc3MiLCJzY29wZSI6Im9wZW5pZCBlbWFpbCIsImF1dGhfdGltZSI6MTczMzk3OTk3NiwiZXhwI
 * joxNzM0MTIyNzA0LCJpYXQiOjE3MzQxMTkxMDQsImp0aSI6Ijc1ZGI0YjUxLWVjZTMtNDllOC04ODkzLTM4NjZmOTM2MTgyNCIsInVzZXJuYW1lIjoibWlrZSJ9
 * .
 * kyAdlPVK5i58nPDE3HVB_ZqrAVkU4xVj4sPA0x7gwKOlUveV-NBNBt5qQ0ufM5Ny96zkEOLWJPKq9KxB6UWibZeDgyVIRFjK1eo-BOl85NRtAvxkpnt_RjP7120yUtoXbpEfIKewJTAxQePL3QiBfDd31D1cHiY
 * pgtPNzmUaoT4KprDTtw9b6pGzQOUPt236J4fSXoVMpthgb2H8p2eo9d1qQ7Vg3BVSi5BJq3mqLZ8QSOxNouO0J-TkTCRVPMKcoG_fn_h8m0Ye9EiNV9VARqP3rcNhyteWktLCw1rRKewpLfc2Z9wg0fapP2-rIO
 * MzxPTh4e5VMtwqmNCkExjbmA
 * 
 * {
 *   "kid":"jCWdN4btMTTylJ8aKP39PIBonoDeCMYzmbzf1\/ZIuw8=",
 *   "alg":"RS256"
 * }
 * {
 *   "sub":"294e8408-b0a1-70a5-b511-0db561f1e30f",
 *   "iss":"https:\/\/cognito-idp.ap-southeast-2.amazonaws.com\/ap-southeast-2_9XULCuO9P",
 *   "version":2,
 *   "client_id":"4d3e6ddnmg7jmgpgbhmbjv9vc8",
 *   "origin_jti":"7c6b62e2-d14b-4845-958b-f78c0e31656d",
 *   "event_id":"f1dacd43-78fd-4dae-a72d-b604a8b16dfa",
 *   "token_use":"access",
 *   "scope":"openid email",
 *   "auth_time":1733979976,
 *   "exp":1734122704,              // 39.65 hours?
 *   "iat":1734119104,
 *   "jti":"75db4b51-ece3-49e8-8893-3866f9361824",
 *   "username":"mike"
 * }
 * **encrypted block**
 * 
 * 
 * @returns 
 */
export const LoggedIn = () => {
  const auth = useAuth();

  const navigate = useNavigate();
  // setInterval(() => {
  //   auth.events.addAccessTokenExpiring(() => {
  //     auth.removeUser()
  //   })   
  //   auth.events.addAccessTokenExpired(() => {
  //     auth.removeUser()
  //   })
  // }, 2000);

  useEffect(() => {
    return auth.events.addAccessTokenExpiring(() => {

      if (auth.user?.expires_in === 0) {
        auth.removeUser();
        // user may be in a route that needs auth, so go back to safe zone
        navigate('/')
      }
      // HTTP 400 and error unsupported_token_type is returned if the token sent in the revocation request is not a refresh token
      // react-oidc-client seems to have a bug here
      // auth.revokeTokens().catch(e => {
      //   console.log(e)
      // })
    })    
  }, [auth.events, auth.removeUser]);

  return (
    <Wrapper>
      {auth.isLoading &&(<div>Loading...</div>)}
  
      {auth.error && (<div className='pad-top-bot'>Error... {auth.error.message}</div>)}
  
      {!auth.isLoading && (
        <div className='login-container pad-top-bot'>
          <button className='btn' style={{maxWidth: '80px', maxHeight: '30px'}} onClick={() => {
              if(auth.isAuthenticated) {
                auth.removeUser()
              } else {
                auth.signinRedirect()
              }}
            }
          >
            {auth.isAuthenticated ? 'Logout' : 'Login'}
          </button>
          <p className='user-name-para'>
            {!auth.error && auth.isAuthenticated ? auth.user?.profile.preferred_username || auth.user?.profile.email : ''}       
          </p>
        </div>
      )}
    </Wrapper>
  )
}